import React from 'react';
import styles from './StanAccordionHeader.module.css';
import IconChevronDown from '@/assets/icons/ic-chevron-down.svg';
import { cn, createIconElement } from '@/lib';
import { StanAccordionHeaderProps } from '../StanAccordion.types';
import { useAccordionContext, useAccordionItemContext } from '../StanAccordion.context';
import { Slot } from '../../Slot';

export const StanAccordionHeader: React.FC<StanAccordionHeaderProps> = ({
    children,
    className = '',
    hideEndIcon = false,
    startIcon,
    asChild = false,
}) => {
    const { id } = useAccordionItemContext();
    const { isItemOpen, toggleItem } = useAccordionContext();
    const open = isItemOpen(id);
    const BareChevronIcon = createIconElement(IconChevronDown);
    const StartIcon = startIcon ? createIconElement(startIcon) : null;
    const isTextOnly = typeof children === 'string' || typeof children === 'number';

    if (asChild) {
        return (
            <Slot
                className={cn(styles.accordionHeader, open && styles.open, className)}
                onClick={() => toggleItem(id)}
                aria-expanded={open}
                aria-controls={`stan-accordion-body-${id}`}
            >
                {children}
            </Slot>
        );
    }

    return (
        <button
            className={cn(styles.accordionHeader, open && styles.open, className)}
            onClick={() => toggleItem(id)}
            type='button'
            aria-expanded={open}
            aria-controls={`stan-accordion-body-${id}`}
        >
            <span className={styles.headerContent}>
                {StartIcon && <span className={styles.startIcon}>{StartIcon}</span>}
                {isTextOnly ? <h3>{children}</h3> : children}
            </span>
            {!hideEndIcon && <span className={cn(styles.endIcon, open && styles.iconOpen)}>{BareChevronIcon}</span>}
        </button>
    );
};
